import { ApiClientAxios, apiFactoryConfig, ChangeFundsRequest } from "@repo/api";
import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
//This mutation includes smsCode for verification
//Make sure to call useSmsVerificationCodeMutation first to send the code to user's phone
//Then pass the code along with ChangeFundsRequest
type ChangeFundsVariables = { contractId: string; data: ChangeFundsRequest };

export const useInvestmentStrategyMutation = (
    options?: Partial<UseMutationOptions<void, Error, ChangeFundsVariables>>,
) => {
    const queryClient = useQueryClient();

    const api = ApiClientAxios.ContractsDpsApiFactory(...apiFactoryConfig);
    return useMutation<void, Error, ChangeFundsVariables>({
        mutationFn: async ({ contractId, data }: ChangeFundsVariables) => {
            await api.changeDPSFundsV2Post(contractId, data); //New endpoint for dps funds change
        },
        onSuccess: async () => {
            // Invalidate any queries or perform any side effects here if needed
            await queryClient.invalidateQueries({ queryKey: ["allowedChanges"] });
            await queryClient.invalidateQueries({ queryKey: ["dpsAllowedChanges"] });
        },
        ...options,
    });
};
